module.exports = __webpack_public_path__ + "img/four.48b99d57.png";